module.exports = __webpack_public_path__ + "img/activeBulletPoint.e79b5ccf.svg";